export default __webpack_public_path__ + "static/media/roller3.491c64f0.gif";